/*
 * @Author: cc
 * @Date: 2020-03-31 16:16:47
 * @LastEditTime: 2021-03-03 09:57:18
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\website\fragmentManagement\singleImage\singleImage.js
 * @Description: 
 */
/**
 * Created by chenchen on 2015/9/10.
 */
/* 单个图片模态框控制器与指令*/
'use strict';
angular.module('pieceMgr.singleImage', ['util.smallIcon', 'pieceMgr.singleImgdir']);
